var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "network_menu",
    attrs: {
      "connected": _vm.status === 'connected'
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.closeMenu($event);
      }
    }
  }, [_c('div', {
    staticClass: "toggle_but",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_vm.status === 'connected' ? _c('img', {
    attrs: {
      "src": require("@/assets/network_on.svg")
    }
  }) : _c('div', [_vm.$root.theme === 'day' ? _c('img', {
    attrs: {
      "src": require("@/assets/network_off_dark.svg")
    }
  }) : _c('img', {
    attrs: {
      "src": require("@/assets/network_off.svg")
    }
  })]), _vm.status === 'connected' ? _c('button', {
    staticClass: "but_primary"
  }, [_vm._v(" " + _vm._s(_vm.activeNetwork.name) + " ")]) : _vm.status === 'connecting' ? _c('button', [_vm._v("Connecting...")]) : _c('button', [_vm._v("Disconnected")]), _c('fa', {
    staticClass: "caret",
    attrs: {
      "icon": "angle-down"
    }
  })], 1), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.isModalOpen ? _c('div', {
    key: "body",
    staticClass: "network_body"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm.page === 'list' ? [_c('h4', [_vm._v("Select Network")])] : _vm._e()], 2), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.page === 'list' ? _c('ListPage') : _vm._e()], 1)], 1) : _vm._e(), _vm.isModalOpen ? _c('div', {
    key: "bg",
    staticClass: "network_dispose_bg",
    on: {
      "click": _vm.closeMenu
    }
  }) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }